const SYNONYMS = [
  { keys: ['him', 'men', 'man', 'male', 'boy', 'gentleman', 'gents'], gender: 'MEN' },
  { keys: ['her', 'women', 'woman', 'female', 'girl', 'lady', 'ladies'], gender: 'WOMEN' },
  { keys: ['unisex', 'everyone', 'both'], gender: 'UNISEX' },
  { keys: ['office', 'work', 'corporate', 'boardroom', 'daily', 'everyday'], tag: 'Office' },
  { keys: ['date', 'romantic', 'night', 'evening'], tag: 'Date Night' },
  { keys: ['party', 'club', 'loud'], tag: 'Party' },
  { keys: ['oud', 'oudh', 'wood'], note: 'oud' },
  { keys: ['rose', 'floral', 'flower'], note: 'rose' },
  { keys: ['citrus', 'lemon', 'bergamot', 'fresh'], note: 'citrus' },
  { keys: ['aquatic', 'marine', 'sea', 'ocean', 'water', 'fresh'], note: 'marine' },
  { keys: ['amber', 'warm', 'spicy', 'spice'], note: 'amber' },
  { keys: ['sweet', 'vanilla', 'gourmand'], note: 'vanilla' },
];

const ALIASES = [
  { keys: ['aventus', 'creed', 'pineapple', 'boardroom'], slugs: ['aventus'] },
  { keys: ['sauvage', 'savage', 'dior', 'sauvage edge'], slugs: ['savage-edge'] },
  { keys: ['ombre', 'nomade', 'lv', 'louis', 'wanderer'], slugs: ['ombre-nomade'] },
  { keys: ['bombshell', 'victoria', 'secret'], slugs: ['bombshell'] },
  { keys: ['cool water', 'davidoff', 'coolwater'], slugs: ['cool-water', 'cool-water-women'] },
  { keys: ['royal white', 'signature'], slugs: ['royal-white'] },
  { keys: ['rose oud', 'rose and oud'], slugs: ['rose-and-oud'] },
  { keys: ['dark secret', 'cherry', 'tonka'], slugs: ['dark-secret'] },
];

function norm(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/[@&]/g, ' and ')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

function haystack(product) {
  const notes = product.notes
    ? [...(product.notes.top || []), ...(product.notes.middle || []), ...(product.notes.base || [])]
    : [];
  return norm(
    [
      product.name,
      product.slug,
      product.code,
      product.tagline,
      product.family,
      product.gender,
      product.type,
      product.badge,
      product.description,
      ...(product.tags || []),
      ...notes,
    ].join(' ')
  );
}

function scoreProduct(product, query) {
  const q = norm(query);
  if (!q) return 0;
  const tokens = q.split(/\s+/).filter(Boolean);
  const hay = haystack(product);
  const name = norm(product.name);
  const slug = norm(product.slug);
  let score = 0;

  if (name === q || slug === q) score += 120;
  else if (name.startsWith(q)) score += 90;
  else if (name.includes(q)) score += 70;
  else if (slug.includes(q.replace(/\s/g, '-'))) score += 65;

  tokens.forEach((token) => {
    if (name.includes(token)) score += 24;
    else if (hay.includes(token)) score += 10;
    SYNONYMS.forEach((syn) => {
      if (!syn.keys.includes(token)) return;
      if (syn.gender && product.gender === syn.gender) score += 28;
      if (syn.tag && (product.tags || []).some((t) => norm(t).includes(norm(syn.tag)))) score += 22;
      if (syn.note && hay.includes(syn.note)) score += 18;
    });
    ALIASES.forEach((alias) => {
      if (alias.keys.some((k) => k.includes(token) || token.includes(k.split(' ')[0]))) {
        if (alias.slugs.includes(product.slug)) score += 40;
      }
    });
  });

  ALIASES.forEach((alias) => {
    if (alias.keys.some((k) => q.includes(k)) && alias.slugs.includes(product.slug)) score += 50;
  });

  return score;
}

export const SEARCH_HINTS = ['Oud', 'For him', 'For her', 'Office', 'Date night', 'Fresh', 'Rose', 'Aventus'];

export function searchProducts(products, query, limit = 8) {
  const q = String(query || '').trim();
  if (!q) return [];
  return products
    .map((product) => ({ product, score: scoreProduct(product, q) }))
    .filter((row) => row.score > 8)
    .sort((a, b) => b.score - a.score || a.product.name.localeCompare(b.product.name))
    .slice(0, limit)
    .map((row) => row.product);
}
